export var DOCUMENT_DELETE_ERROR = 'Hiba a dokumentum törlése során!';
export var TASK_CREATE_ERROR = 'Hiba a ticket rögzítése során!';
export var DEVELOPER_DOCUMENTATION_CREATE_ERROR = 'Hiba a fejlesztői dokumentáció létrehozásával!';
export var DOCUMENT_TYPE_NOT_SELECTED = 'Nincs kíválasztva a feltölteni kívánt dokumentum típusa!';



//////////////////
// WEBPACK FOOTER
// ./src/constants/errors.ts
// module id = 173
// module chunks = 0